import React, { useState } from 'react'
// import { Line } from '@ant-design/charts'
import './styles.css'
// import '../index.css'
import { Typography } from 'antd'

const { Title, Paragraph, Text } = Typography

const BarGraphFloodFrequency = props => {
  // FreqFlood={FreqFlood}
  // NoneFlood={NoneFlood}
  // OccFlood={OccFlood}
  // RareFlood={RareFlood}
  // VeryFreqFlood={VeryFreqFlood}
  // VeryRare={VeryRare}

  // populate chart details for flood frequency
  let chartSource2 = []

  chartSource2 = [
    {
      val1: 'Very Rare',
      cost1: props.VeryRare,
      costNum1: props.VeryRare,
      color1: '#66B596',

      val2: 'Rare',
      cost2: props.RareFlood,
      costNum2: props.RareFlood,
      color2: '#F5D466',

      val3: 'Occasional',
      cost3: props.OccFlood,
      costNum3: props.OccFlood,
      color3: '#F5D466',

      val4: 'Frequent',
      cost4: props.FreqFlood,
      costNum4: props.FreqFlood,
      color4: '#E3A5A1',

      val5: 'Very Frequent',
      cost5: props.VeryFreqFlood,
      costNum5: props.VeryFreqFlood,
      color5: '#CD615A',

      val6: 'None',
      cost6: props.NoneFlood,
      costNum6: props.NoneFlood,
      color6: '#A7A9AB'
    }
  ]

  // console.log(chartSource2)

  return (
    <main>
      <strong>Flood Frequency</strong>
      <div>
        <br />
        <table
          id="FloodFreqChart"
          class="charts-css column show-primary-axis show-5-secondary-axes data-spacing-5 labels-align-center"
        >
          <thead>
            <tr>
              <th scope="col"> Year </th> <th scope="col"> Progress </th>
            </tr>
          </thead>{' '}
          <tbody>
            <tr>
              <th scope="row"> {chartSource2[0]?.val1} </th>{' '}
              <td
                style={{
                  '--size': `calc( ${chartSource2[0]?.costNum1} / (100) )`,
                  '--color': `${chartSource2[0]?.color1}`
                }}
              >
                <Choose>
                  <When condition={chartSource2[0]?.cost1 != 0}>
                    <span class="data"> {chartSource2[0]?.cost1} </span>
                    <span class="tooltip">
                      {' '}
                      {chartSource2[0]?.cost1} % Very Rare.
                    </span>
                  </When>
                </Choose>
              </td>
            </tr>{' '}
            <tr>
              <th scope="row"> {chartSource2[0]?.val2} </th>{' '}
              <td
                style={{
                  '--size': `calc( ${chartSource2[0]?.costNum2} / (100) )`,
                  '--color': `${chartSource2[0]?.color2}`
                }}
              >
                <Choose>
                  <When condition={chartSource2[0]?.cost2 != 0}>
                    <span class="data"> {chartSource2[0]?.cost2} </span>
                    <span class="tooltip">
                      {' '}
                      {chartSource2[0]?.cost2} % Rare.
                    </span>
                  </When>
                </Choose>
              </td>
            </tr>{' '}
            <tr>
              <th scope="row"> {chartSource2[0]?.val3} </th>{' '}
              <td
                style={{
                  '--size': `calc( ${chartSource2[0]?.costNum3} / (100) )`,
                  '--color': `${chartSource2[0]?.color3}`
                }}
              >
                <Choose>
                  <When condition={chartSource2[0]?.cost3 != 0}>
                    <span class="data"> {chartSource2[0]?.cost3} </span>
                    <span class="tooltip">
                      {' '}
                      {chartSource2[0]?.cost3} % Occasional.
                    </span>
                  </When>
                </Choose>
              </td>
            </tr>{' '}
            <tr>
              <th scope="row"> {chartSource2[0]?.val4} </th>{' '}
              <td
                style={{
                  '--size': `calc( ${chartSource2[0]?.costNum4} / (100) )`,
                  '--color': `${chartSource2[0]?.color4}`
                }}
              >
                <Choose>
                  <When condition={chartSource2[0]?.cost4 != 0}>
                    <span class="data"> {chartSource2[0]?.cost4} </span>
                    <span class="tooltip">
                      {' '}
                      {chartSource2[0]?.cost4} % Frequent.
                    </span>
                  </When>
                </Choose>
              </td>
            </tr>{' '}
            <tr>
              <th scope="row"> {chartSource2[0]?.val5} </th>{' '}
              <td
                style={{
                  '--size': `calc( ${chartSource2[0]?.costNum5} / (100) )`,
                  '--color': `${chartSource2[0]?.color5}`
                }}
              >
                <Choose>
                  <When condition={chartSource2[0]?.cost5 != 0}>
                    <span class="data"> {chartSource2[0]?.cost5} </span>
                    <span class="tooltip">
                      {' '}
                      {chartSource2[0]?.cost5} % Very Frequent.
                    </span>
                  </When>
                </Choose>
              </td>
            </tr>{' '}
            <tr>
              <th scope="row"> {chartSource2[0]?.val6} </th>{' '}
              <td
                style={{
                  '--size': `calc( ${chartSource2[0]?.costNum6} / (100 ) )`,
                  '--color': `${chartSource2[0]?.color6}`
                }}
              >
                <Choose>
                  <When condition={chartSource2[0]?.cost6 != 0}>
                    <span class="data"> {chartSource2[0]?.cost6} </span>
                    <span class="tooltip">
                      {' '}
                      {chartSource2[0]?.cost6} % None.
                    </span>
                  </When>
                </Choose>
              </td>
            </tr>{' '}
          </tbody>
        </table>
        {/* <br /> */}
        <div
          class="primary-axis"
          style={{
            textAlign: 'center',
            padding: '0px 0px 20px 0px'
          }}
        >
          {' '}
          <i>Increasing Frequency (Very Rare to Frequent)</i>{' '}
        </div>
      </div>
    </main>
  )
}

export default BarGraphFloodFrequency
